function encode(obj, pfx) {
  var k,
      i,
      tmp,
      str = '';

  for (k in obj) {
    if ((tmp = obj[k]) !== void 0) {
      if (Array.isArray(tmp)) {
        for (i = 0; i < tmp.length; i++) {
          str && (str += '&');
          str += encodeURIComponent(k) + '=' + encodeURIComponent(tmp[i]);
        }
      } else {
        str && (str += '&');
        str += encodeURIComponent(k) + '=' + encodeURIComponent(tmp);
      }
    }
  }

  return (pfx || '') + str;
}

function toValue(mix) {
  if (!mix) return '';
  var str = decodeURIComponent(mix);
  if (str === 'false') return false;
  if (str === 'true') return true;
  return +str * 0 === 0 ? +str : str;
}

function decode(str) {
  var tmp,
      k,
      out = {},
      arr = str.split('&');

  while (tmp = arr.shift()) {
    tmp = tmp.split('=');
    k = tmp.shift();

    if (out[k] !== void 0) {
      out[k] = [].concat(out[k], toValue(tmp.shift()));
    } else {
      out[k] = toValue(tmp.shift());
    }
  }

  return out;
}

/**
 * - Store properties range from 0 (Sunday) - 6 (Saturday)
 * - Store values are in Military Time, all in PST
 * - "adr_GezSSC9M"/"adr_K6s3Kaja" are the IDs of each store
 * found in ./stores.js
 * - "0: [9, 19]" is equivalent to "Sunday: [9am, 7pm]"
 */
const storeHours = {
  // San Francisco, Market St
  adr_GezSSC9M: {
    0: [9, 19],
    1: [9, 20],
    2: [9, 20],
    3: [9, 20],
    4: [9, 20],
    5: [9, 20],
    6: [9, 20]
  },
  // Emeryville, Horton St
  adr_K6s3Kaja: {
    0: [10, 19],
    1: [10, 19],
    2: [10, 19],
    3: [10, 19],
    4: [10, 19],
    5: [10, 19],
    6: [10, 19]
  },
  // It is unclear what this is for. It does not appear to be used.
  // @todo Remove the `adr_oak` proper if it is not used.
  adr_oak: {
    0: [7, 18],
    1: [7, 19],
    2: [7, 19],
    3: [7, 19],
    4: [7, 19],
    5: [7, 19],
    6: [7, 18]
  },
  // San Francisco - Potrero, 16th St
  adr_sfpotrero: {
    0: [10, 19],
    1: [10, 19],
    2: [10, 19],
    3: [10, 19],
    4: [10, 19],
    5: [10, 19],
    6: [10, 19]
  }
};

/**
 * Transforms Military Time to Standard Time
 * @param {number} time - Military Time (0 - 23)
 * @returns {number} - Standard Time
 */

const militaryToStandardTime = time => (time + 11) % 12 + 1;
/**
 * Lookup store and determine open/close time by day offset
 * @param {Object} params
 * @param {string} params.storeId - A store ID
 * @param {number} params.day - Day of the week (0 Sunday - 6 Saturday)
 * @returns {{open?: number, close?: number}} The store's opening and closing time of the specified day
 */


const getStoreOpenClose = ({
  storeId,
  day
}) => {
  var _storeDay, _storeDay2;

  const store = storeHours[storeId];
  let storeDay = null;

  if (day > 6) {
    storeDay = store[0];
  } else if (day < 0) {
    storeDay = store[6];
  } else {
    storeDay = store[day];
  }

  return {
    open: (_storeDay = storeDay) == null ? void 0 : _storeDay[0],
    close: (_storeDay2 = storeDay) == null ? void 0 : _storeDay2[1]
  };
};
/**
 * @param {string} storeId Store ID,  e.g. 'adr_sfpotrero' (not a Shopify id),
 */

const getStoreHours = storeId => {
  const hoursOfOperation = {};
  moment.tz.add('America/Los_Angeles|PST PDT|80 70|0101|1Lzm0 1zb0 Op0');
  const date = moment().tz('America/Los_Angeles');
  const hour = parseInt(date.format('H'), 10);
  const day = date.weekday();
  const store = {
    yesterday: getStoreOpenClose({
      storeId,
      day: day - 1
    }),
    today: getStoreOpenClose({
      storeId,
      day
    }),
    tomorrow: getStoreOpenClose({
      storeId,
      day: day + 1
    })
  };

  if (hour >= store.today.open && hour < store.today.close) {
    hoursOfOperation.today = "Open until " + militaryToStandardTime(store.today.close) + "pm";
  } else if (hour >= store.today.close && hour < 24) {
    hoursOfOperation.today = "Open " + militaryToStandardTime(store.tomorrow.open) + "am to " + militaryToStandardTime(store.tomorrow.close) + "pm";
  } else if (hour >= 0 && hour < store.tomorrow.open) {
    hoursOfOperation.today = "Open " + militaryToStandardTime(store.today.open) + "am to " + militaryToStandardTime(store.today.close) + "pm";
  }

  hoursOfOperation.tomorrow = "Open " + militaryToStandardTime(store.tomorrow.open) + "am to " + militaryToStandardTime(store.tomorrow.close) + "pm";
  return hoursOfOperation;
};

/**
 * Parses variant id out of the URL
 */

const getUrlVariant = () =>
/** @type {{variant?: number}} */
decode(window.location.search.substr(1)).variant;

export { getStoreHours as a, getUrlVariant as b, decode as d, encode as e, getStoreOpenClose as g };
